"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GD = void 0;
exports.GD = {
    numericCode: '308',
    alpha2Code: 'GD',
    alpha3Code: 'GRD',
    englishName: {
        short: 'Grenada',
        full: 'Grenada',
    },
    names: {
        full: {
            en: 'Grenada',
            fr: 'Grenade (la)',
        },
        short: {
            en: 'Grenada',
            fr: 'Grenade (la)',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'GD-01': {
            numericCode: '308',
            code: 'GD-01',
            category: {
                id: '242',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint Andrew',
            },
        },
        'GD-02': {
            numericCode: '308',
            code: 'GD-02',
            category: {
                id: '242',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint David',
            },
        },
        'GD-03': {
            numericCode: '308',
            code: 'GD-03',
            category: {
                id: '242',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint George',
            },
        },
        'GD-04': {
            numericCode: '308',
            code: 'GD-04',
            category: {
                id: '242',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint John',
            },
        },
        'GD-05': {
            numericCode: '308',
            code: 'GD-05',
            category: {
                id: '242',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint Mark',
            },
        },
        'GD-06': {
            numericCode: '308',
            code: 'GD-06',
            category: {
                id: '242',
                names: {
                    en: {
                        singular: 'parish',
                        plural: 'parishes',
                    },
                    fr: {
                        singular: 'paroisse',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Saint Patrick',
            },
        },
        'GD-10': {
            numericCode: '308',
            code: 'GD-10',
            category: {
                id: '351',
                names: {
                    en: {
                        singular: 'dependency',
                        plural: 'dependencies',
                    },
                    fr: {
                        singular: 'dépendance',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Southern Grenadine Islands',
            },
        },
    },
    cities: [
        {
            name: "Saint George's",
            subdivision: 'Saint George',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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